export default "__VITE_ASSET__CKFm0BEt__"